import { Box, Stack } from "@mui/material";
import { VideoCameraFront } from "@mui/icons-material";
import { LargeContentBox } from "@/components/common";
import { PageHeader } from "@/components/common/PageHeader";
import { TeleconsultoriaAvailabilityPanel } from "src-next/modules/teleconsultoria";

export function TeleconsultoriaPage() {
  return (
    <LargeContentBox>
      {/* Mesmo encaixe do Pronto Atendimento: a grade centraliza o filho se ele não esticar. */}
      <Box sx={{ width: "100%", maxWidth: "100%", justifySelf: "stretch" }}>
        <PageHeader
          title="Teleconsultoria"
          icon={VideoCameraFront}
          description="Fique disponível para entrar na videochamada de um atendimento."
        />
        <Stack sx={{ width: "100%" }}>
          <Box sx={{ width: "100%", maxWidth: "100%", p: 2 }}>
            <TeleconsultoriaAvailabilityPanel />
          </Box>
        </Stack>
      </Box>
    </LargeContentBox>
  );
}
